import { makeAutoObservable } from 'mobx';

import type { MixAndMatchProgress } from '~/utils/mixAndMatch';

/**
 * Open state of the DubaiExpress cart drawer. Only click handlers and a
 * client-side reaction change it, so the module-level instance never carries
 * state from one server render to the next.
 */
class CartDrawerStore {
  isOpen = false;

  /** Sku of the offer added last; its row leads the list. */
  lastSku: string | null = null;

  /**
   * Saving charged the last time Mix & Match was unlocked. Kept while the
   * cart still holds eligible units, so dropping below the threshold can be
   * reported as a lost discount; forgotten once they are all gone.
   */
  lastAppliedSavings: number | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  /** Opens the drawer after an item was added, remembering which one. */
  open(sku?: string | null) {
    this.isOpen = true;
    this.lastSku = sku ?? null;
  }

  close() {
    this.isOpen = false;
  }

  /** Records the unlocked saving; forgets it once no eligible unit is left. */
  trackPromo(progress: MixAndMatchProgress | null, eligibleUnits: number) {
    if (eligibleUnits === 0) {
      this.lastAppliedSavings = null;
      return;
    }

    if (progress?.isUnlocked) {
      this.lastAppliedSavings = progress.savings;
    }
  }
}

export const cartDrawerStore = new CartDrawerStore();
